import React, {FC} from "react";
import {useAuthenticator} from "../authentication/useAuthenticator";
import {Outlet} from "react-router-dom";
import {LoginPanel} from "../components/LoginPanel";

export const AuthenticationRequiredWrapper: FC = () => {
    const {isAuthenticated} = useAuthenticator();

    if (!isAuthenticated)
    {
        return <LoginPanel/>;
    }

    return <Outlet />;

}